<template>
    <div class="report_config">
        <div style="text-align: right;margin-bottom: 20px">
            <el-button class="leader-common-button" @click="saveConfig"
                >保存</el-button
            >
        </div>
        <div class="table-wrap">
            <el-scrollbar style="height: 100%">
                <el-form
                    :model="configForm"
                    ref="configForm"
                    class="leader-style-form"
                >
                    <el-table
                        border
                        :data="configForm.list"
                        class="leader-style-table"
                        height="550px"
                    >
                        <el-table-column width="50" align="center" label="序号">
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.$index + 1 }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="点位名称"
                            property="remark"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="价格"
                            align="center"
                            width="200"
                        >
                            <template slot-scope="scope">
                                <el-form-item
                                    :prop="'list.' + scope.$index + '.price'"
                                    :rules="[
                                        {
                                            required: true,
                                            message: '请填写价格',
                                            trigger: 'blur'
                                        }
                                    ]"
                                >
                                    <el-input
                                        v-model="scope.row.price"
                                        maxlength="100"
                                        clearable
                                        v-Int.float
                                    ></el-input
                                ></el-form-item>
                            </template> </el-table-column
                    ></el-table>
                </el-form>
            </el-scrollbar>
        </div>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
export default {
    data() {
        return {
            configForm: {
                list: []
            }
        };
    },
    mounted() {
        this.getReportConfigList();
    },
    methods: {
        getReportConfigList() {
            api.getReportConfigList().then(res => {
                if (res && res.error_code == 0) {
                    this.configForm.list = res.bus_json;
                }
            });
        },
        saveConfig() {
            this.$refs["configForm"].validate(valid => {
                if (valid) {
                    api.updateConfigList(this.configForm.list).then(res => {
                        if (res && res.error_code == 0) {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getReportConfigList();
                        }
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
.report_config {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 20px;
}
</style>
